type ArchivableWorkOrder = {
  archived?: boolean | null;
  parentWorkOrder?: { _id?: string } | null;
};

/** Sub work orders are archived with their parent and can only be restored
 *  through it — the backend rejects unarchiving them directly. */
export const canUnarchiveWorkOrder = (
  workOrder: ArchivableWorkOrder | null | undefined,
  isOemAdmin: boolean,
): boolean =>
  !!isOemAdmin && !!workOrder?.archived && !workOrder.parentWorkOrder?._id;
